import {
  getWaitingMember,
  type WaitingMember,
} from '../../shared/waitingMember';
import { getMembersMap } from '../../features/realtime/realtime.selectors';
import { getWaitingRoom } from '../../features/waitingRoom/waitingRoom.selectors';
import { useAppSelector } from '../useReduxToolkit';
import { useRoomHostName } from '../useRoomHostName';
import { getWaitingOfflineProvider } from './helpers';

export type UsePatientViewWaitingProvidersReturnType = {
  waitingProviders: WaitingMember[];
};

/**
 * Returns a list of providers data for the patient view waiting room.
 * Uses default data if provider is offline; otherwise, realtime data if online.
 */
export const usePatientViewWaitingProviders =
  (): UsePatientViewWaitingProvidersReturnType => {
    const realtimeMembersMap = useAppSelector(getMembersMap);
    const waitingRoomInitialData = useAppSelector(getWaitingRoom);
    const providerName = useRoomHostName(waitingRoomInitialData);

    const waitingProviders =
      Object.values(realtimeMembersMap).map(getWaitingMember);

    if (waitingProviders.length > 0) {
      return { waitingProviders };
    }

    const waitingProviderInitial = getWaitingOfflineProvider(
      waitingRoomInitialData,
      providerName,
    );

    return {
      waitingProviders: [waitingProviderInitial],
    };
  };
